import type { ReactElement } from 'react';

export function Dashboard(): ReactElement {
  return (
    <section className="flex min-h-full items-center justify-center p-6">
      <div
        className="flex w-full max-w-md flex-col items-center gap-4 rounded-2xl border p-8 text-center shadow-sm"
        style={{
          background: 'var(--bg-surface)',
          borderColor: 'var(--border)',
          color: 'var(--text-main)',
        }}
      >
        <div className="text-6xl" aria-hidden="true">
          👨‍🍳
        </div>
        <h1 className="text-2xl font-semibold">Welcome to ChefCook</h1>
        <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
          Plan meals, track nutrition, and shop smarter.
        </p>
      </div>
    </section>
  );
}
